import { vModelText as _vModelText, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../img/searchBar.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-194b7966")

_pushScopeId("data-v-194b7966")
const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "search_icon" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode("input", {
      ref: "input",
      type: "search",
      tabindex: _ctx.tabIndex,
      readonly: _ctx.readonly,
      "onUpdate:modelValue": [
        _cache[1] || (_cache[1] = ($event: any) => (_ctx.localValue = $event)),
        _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
      ]
    }, null, 8, ["tabindex", "readonly"]), [
      [_vModelText, _ctx.localValue],
      [_directive_localizedPlaceholder, { key: _ctx.placeholderKey, value: _ctx.placeholderValue, prevText: _ctx.placeholderPrevText, afterText: _ctx.placeholderAfterText }]
    ]),
    _hoisted_2
  ]))
})